module.exports = __webpack_public_path__ + "static/assets/a697f949e80b4629c279c2148167e3e5.svg";